import React from "react";
import { object, bool, func, string } from "prop-types";
import { Link } from "@quintype/components";

import LinkView from "../link-view";
import Whatsapp from "../../atoms/icons/whatsapp";
import PregaNewsIcon from "../../atoms/icons/prega-news-icon";

import "./menuItem.m.css";

const MenuItem = ({ item, isPopup, closePopup, navigateToPage, currentHostUrl }) => {
  const onMenuClick = (url) => (e) => {
    e.preventDefault();

    closePopup();
    navigateToPage(url);
  };

  const getView = (url) => {
    if (isPopup) {
      return (
        <div styleName="wrapper-link" onClick={onMenuClick(url)}>
          {item.title}
        </div>
      );
    }

    if (item.title === "#PrivacyMatters") {
      return (
        <div styleName="tooltip">
          <span styleName="tooltiptext">
            powered by&nbsp;
            <Whatsapp />
          </span>
          <Link href={url}>{item.title}</Link>
        </div>
      );
    }

    if (item.title === "#SheIsCompleteInHerself") {
      return (
        <div styleName="tooltip">
          <span styleName="tooltiptext">
            powered by&nbsp;
            <PregaNewsIcon />
          </span>
          <Link href={url}>{item.title}</Link>
        </div>
      );
    }

    return <Link href={url}>{item.title}</Link>;
  };

  const getLinkView = () => {
    // Check if its same host
    // console.log("currentHostUrl===", currentHostUrl, item.title);
    // if (currentHostUrl && item.completeUrl.includes(currentHostUrl)) {
    //   const newSlug = item.completeUrl.replace(currentHostUrl, ""); // Get only the slug from the url
    //   console.log("newSlug===",newSlug);

    //   return getView(newSlug);
    // }

    return <LinkView link={item.completeUrl}>{item.title}</LinkView>;
  };

  return item.isExternalLink ? getLinkView() : getView(item.completeUrl);
};

MenuItem.defaultProps = {
  isPopup: false,
};

MenuItem.propTypes = {
  item: object,
  isPopup: bool,
  closePopup: func,
  navigateToPage: func,
  currentHostUrl: string,
};

export default MenuItem;
